// extracted by mini-css-extract-plugin
module.exports = {"path":"Paths_path__1qJi1","paths":"Paths_paths__2DdHU"};